module.exports = __webpack_public_path__ + "static/img/nav19.1eab7c91.svg";